<template>
  <transition>
    <div class="mask" v-if="show">
      <div class="modal" :style="{width: width + 'px'}">
        <div class="modal-content">
          <i class="el-icon-close close" @click.stop="close"></i>
          <div class="modal-header">
            <div class="modal-title">{{title}}</div>
            <slot name="header"/>
          </div>
          <div class="modal-body">
            <slot name="content"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="stylus" scoped>
.mask {
  position: fixed;
  overflow: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  -webkit-overflow-scrolling: touch;
  outline: 0;
  background-color: rgba(55, 55, 55, 0.6);
}
.modal {
  position: fixed;
  width: auto;
  margin: 0 auto;
  top: 100px;
  right: 0;
  bottom: 0;
  left: 0;
  padding-bottom: 24px;
  width: 340px;
}
.modal-content {
  border-radius: 18px;
  width: 100%;
  max-height: 600px;
  margin: auto;
  position: relative;
  background-color: #fff;
  border: 0;
  background-clip: padding-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.close {
  cursor: pointer;
  position: absolute;
  right: 16px;
  top: 16px;
  z-index: 10;
  font-weight: 600;
  transition: color 0.3s ease;
  color: rgba(0, 0, 0, 0.43);
  font-size: 16px;
  color: #cacaca;
  &:hover {
    color: blue;
  }
}
.modal-header {
  padding: 30px 16px 0;
  border-radius: 14px 14px 0 0;
  background: #fff;
  color: rgba(0, 0, 0, 0.65);
  position: relative;
  text-align: center;
  .modal-title {
    font-size: 1rem;
    line-height: 22px;
    font-weight: 500;
    color: rgba(51,51,51,1);
    letter-spacing: 0;
  }
}
.modal-body {
  padding: 24px 24px 39px;
  font-size: 12px;
  line-height: 1.5;
}
.modal-footer {
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px 10px 10px;
  text-align: right;
  border-radius: 0 0 4px 4px;
}
</style>

<script>
export default {
  name: 'commonModal',
  props: {
    module: String, // 模块名
    title: String,
    value: Boolean,
    width: Number
  },
  data() {
    return {}
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(show) {
        this.$emit('input', show)
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
      this.show = false
    }
  }
}
</script>
